import {BaseTrackingEvent} from '@udemy-v2/event-tracking';

import {LearningProduct} from '@/features/course-landing-page/events/events';

export class CodingExercisePromotionImpressionEvent implements BaseTrackingEvent {
    _type = 'CodingExercisePromotionImpressionEvent';
    learningProduct: {
        id: number;
        trackingId: string;
        type: LearningProduct;
    };

    constructor({id, trackingId}: {id: number; trackingId: string}) {
        this.learningProduct = {id, trackingId, type: LearningProduct.COURSE};
    }
}

export class CodingExercisePromotionImageClickEvent implements BaseTrackingEvent {
    _type = 'CodingExercisePromotionImageClickEvent';
    learningProduct: {
        id: number;
        trackingId: string;
        type: LearningProduct;
    };

    constructor({id, trackingId}: {id: number; trackingId: string}) {
        this.learningProduct = {id, trackingId, type: LearningProduct.COURSE};
    }
}

export class CodingExercisePromotionSeeDemoLinkClickEvent implements BaseTrackingEvent {
    _type = 'CodingExercisePromotionSeeDemoLinkClickEvent';
    learningProduct: {
        id: number;
        trackingId: string;
        type: LearningProduct;
    };

    constructor({id, trackingId}: {id: number; trackingId: string}) {
        this.learningProduct = {id, trackingId, type: LearningProduct.COURSE};
    }
}

export class CodingExercisePromotionDemoVideoImpressionEvent implements BaseTrackingEvent {
    _type = 'CodingExercisePromotionDemoVideoImpressionEvent';
    learningProduct: {
        id: number;
        trackingId: string;
        type: LearningProduct;
    };

    constructor({id, trackingId}: {id: number; trackingId: string}) {
        this.learningProduct = {id, trackingId, type: LearningProduct.COURSE};
    }
}
